import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 13v-10","key":"svg-0"}],["path",{"d":"M12 21l-6 -8h12z","key":"svg-1"}]]

const IconCircuitGroundDigital = createReactComponent('outline', 'circuit-ground-digital', 'CircuitGroundDigital', __iconNode);

export default IconCircuitGroundDigital;